import { useState } from "react";
import { Link } from "react-router-dom";
import Wrapper from "../../components/sectionWrapper";
import { media } from "../../libs/media";
import { useLangContext } from "../../components/translateContext";
import Messages from "./translations/index.json";
import buttonText from "../../translations/button.json";
import { Slide } from "react-reveal";
import {
  PrefillEmbed,
  PrefillLang,
  useCodePenEmbed,
  stripIndent,
} from "react-codepen-prefill-embed";
import CheckOutOverview from "./CheckOutOverview";
import Secured from "../pricing/Secured";
import UssdSystem from "../offlinePayment/UssdSystem";
import CheckOutSimply from "./CheckOutSimply";
import CheckOutFocus from "./CheckoutFocus";
import CheckOutCustom from "./CheckOutCustomize";
import CheckOutOptimized from "./CheckOutOptimized";
import CheckOutSee from "./CheckOutSee";

export default function CheckoutPage() {
  const [stickyDocsHeader, setSticky] = useState(false);
  useCodePenEmbed();
  const { Lang } = useLangContext();
  const Infos = Messages[Lang];
  const btnMsg = buttonText[Lang];
  return (
    <>
      <div className="mt-24">
        <CheckOutOverview/>
        <CheckOutSimply/>
        <CheckOutFocus/>
        <CheckOutCustom/>
        <CheckOutOptimized/>
        <CheckOutSee/>
        <UssdSystem/>
        <Secured/>


  
      </div>
   
    </>
  );
}
